/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Card from "components/Card/Card.js";
import EditIcon from "@material-ui/icons/Edit";
import CardHeader from "components/Card/CardHeader.js";
import axios from "axios";
import Loader from "components/Loader";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
const classes = makeStyles(styles);

class UpdateCategory extends Component {
  state = {
    type: "",
    catData: [],
    courses: [],
    facultyArr: [],
    showBoth: false,
    pkey: "",
    category: "",
    redirect: false,
    notification: false,
    loading: false
  };
  componentDidMount() {
    let categoryData = this.props.location.state.categoryData;
    // console.log(categoryData);
    axios
      // .get("https://admin.akclasses.in/api/coursesR?type=COURSES")
      .get("https://admin.akclasses.in/api/coursesForFilter")
      .then(resp => {
        //console.log(resp.data);
        this.setState(
          {
            courses: resp.data,
            type: categoryData.REF_COURSE_ID,
            category: categoryData.VIEW_VALIDITY_ID,
            pkey: categoryData.PRODUCT_KEY
          },
          () => {
            axios
              .get("https://admin.akclasses.in/api/course/" + this.state.type)
              .then(resp => {
                //console.log(resp.data);
                this.setState({
                  catData: resp.data.product.variant
                });
                let viewIds = [];
                let views = [];
                this.state.catData.forEach(v => {
                  if (viewIds.includes(v.view_and_validity.id) === false) {
                    viewIds.push(v.view_and_validity.id);
                    views.push(v.view_and_validity);
                  }
                });
                //console.log(views);
                this.setState({ catData: views }, () => {
                  this.setState({
                    showBoth: this.state.catData.length >= 1 ? true : false
                  });
                });
              });
          }
        );
      });
    axios.get("https://admin.akclasses.in/api/facultyR").then(resp => {
      //console.log(resp.data);
      this.setState({
        facultyArr: resp.data
      });
    });
  }
  findFaculty = data => {
    let obj = this.state.facultyArr.find(v => v.id === data[0].faculty_id);
    if (obj !== undefined) {
      return obj.name;
    }
  };
  handleSubmit = e => {
    this.setState({
      loading: true
    });
    e.preventDefault();
    let payLoad = {
      ref_course_id: this.state.type,
      view_validity_id: this.state.category,
      product_key: this.state.pkey
    };
    let categoryData = this.props.location.state.categoryData;
    let categoryId = categoryData.ID;
    axios
      .post(
        "https://admin.akclasses.in/api/courseKey/update/" + categoryId,
        payLoad
      )
      .then(() => {
        // console.log(resp);
        setTimeout(() => {
          this.setState({
            redirect: true
          });
        }, 1000);
        this.setState({
          notification: true,
          loading: false
        });
      });
  };
  handleDrop = e => {
    this.setState(
      {
        [e.target.name]: e.target.value,
        showBoth: false
      },
      () => {
        axios
          .get("https://admin.akclasses.in/api/course/" + this.state.type)
          .then(resp => {
            //console.log(resp.data);
            this.setState({
              catData: resp.data.product.variant
            });
            let viewIds = [];
            let views = [];
            this.state.catData.forEach(v => {
              if (viewIds.includes(v.view_and_validity.id) === false) {
                viewIds.push(v.view_and_validity.id);
                views.push(v.view_and_validity);
              }
            });
            //console.log(views);
            this.setState({ catData: views }, () => {
              this.setState({
                showBoth: this.state.catData.length >= 1 ? true : false
              });
            });
          });
      }
    );
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/productkeys"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Product Key Updated!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Product Key</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={5}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Course
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.type}
                            inputProps={{
                              name: "type",
                              id: "simple-select",
                              onChange: e => {
                                this.handleDrop(e);
                              }
                            }}
                          >
                            {this.state.courses.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                key={i}
                                value={v.ID}
                              >
                                {
                                  <span>
                                    {v.TITLE}(
                                    {v.faculties === null
                                      ? "AK Team"
                                      : (v.faculties.name)}
                                    )
                                  </span>
                                }
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>{" "}
                        {this.state.showBoth ? (
                          <div>
                            <FormControl
                              style={{ marginTop: "12px" }}
                              fullWidth
                              className={classes.selectFormControl}
                            >
                              <InputLabel
                                htmlFor="simple-select"
                                className={classes.selectLabel}
                              >
                                Views Validity
                              </InputLabel>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.category}
                                inputProps={{
                                  name: "category",
                                  id: "simple-select",
                                  onChange: e => {
                                    this.setState({
                                      category: e.target.value
                                    });
                                    // //console.log(e.target.value);
                                  }
                                }}
                              >
                                {this.state.catData.map((v, i) => (
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected
                                    }}
                                    key={i}
                                    value={v.id}
                                  >
                                    {v.view_and_validity}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={5}>
                        <CustomInput
                          labelText="Product Key"
                          inputProps={{
                            value: this.state.pkey,
                            required: true,
                            onChange: e =>
                              this.setState({ pkey: e.target.value }, () => {
                                //console.log(this.state.pkey);
                              })
                          }}
                          id="float"
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={5}>
                        <Button className="" type="submit" color="info">
                          {this.state.loading ? (
                            <Loader />
                          ) : (
                            "Update Product Key"
                          )}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/productkeys"
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default UpdateCategory;
